import { render, staticRenderFns } from "./authen_biangeng.vue?vue&type=template&id=01010a55&scoped=true"
import script from "./authen_biangeng.vue?vue&type=script&lang=js"
export * from "./authen_biangeng.vue?vue&type=script&lang=js"
import style0 from "./authen_biangeng.vue?vue&type=style&index=0&id=01010a55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__coffee-script@_nvev6wbrwofx6itvk2x4sio6cy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01010a55",
  null
  
)

export default component.exports